import {
  AiOutlineCarryOut,
  AiOutlineCreditCard,
  AiOutlineScan,
  AiOutlineUsergroupAdd,
} from "react-icons/ai";
import { FiCalendar, FiUserCheck, FiUsers } from "react-icons/fi";
import { GoLocation } from "react-icons/go";
import { IoCarSportOutline, IoIdCardOutline } from "react-icons/io5";
import { MdAddRoad } from "react-icons/md";
import { RiPoliceCarLine } from "react-icons/ri";
import { SiSpeedtest } from "react-icons/si";
import AdminLink from "../../components/shared/AdminLink";
import { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import logo from "../../assets/images/logo-red.png";

export default function Manage({
  children,
  title,
  subtitle,
  description,
  actions,
  hasLogo,
}: any) {
  const { user } = useContext(AuthContext);
  const allMenus = [
    {
      id: 1,
      isActive: true,
      to: "/manage/customers",
      name: "Customers",
      icon: <FiUsers />,
    },
    {
      id: 2,
      isActive: false,
      to: "/manage/bookings",
      name: "Bookings",
      icon: <FiCalendar />,
    },
    {
      id: 3,
      isActive: false,
      to: "/manage/quotations",
      name: "Quotations",
      icon: <AiOutlineCarryOut />,
    },
    {
      id: 12,
      isActive: false,
      to: "/manage/requests",
      name: "New Accounts",
      icon: <AiOutlineUsergroupAdd />,
    },
    {
      id: 4,
      isActive: false,
      to: "/manage/assists",
      name: "Road Assist",
      icon: <MdAddRoad />,
    },
    {
      id: 5,
      isActive: false,
      to: "/manage/testdrives",
      name: "Test Drives",
      icon: <SiSpeedtest />,
    },
    {
      id: 9,
      isActive: false,
      to: "/manage/vehicles",
      name: "Vehicles",
      icon: <RiPoliceCarLine />,
    },
    {
      id: 11,
      isActive: false,
      to: "/manage/qrcodes",
      name: "QR Codes",
      icon: <AiOutlineScan />,
    },
  ];

  const adminMenus = [
    {
      id: 1,
      isActive: true,
      to: "/manage/customers",
      name: "Customers",
      icon: <FiUsers />,
    },
    {
      id: 2,
      isActive: false,
      to: "/manage/bookings",
      name: "Bookings",
      icon: <FiCalendar />,
    },
    {
      id: 3,
      isActive: false,
      to: "/manage/quotations",
      name: "Quotations",
      icon: <AiOutlineCarryOut />,
    },
    {
      id: 12,
      isActive: false,
      to: "/manage/requests",
      name: "New Accounts",
      icon: <AiOutlineUsergroupAdd />,
    },
    {
      id: 4,
      isActive: false,
      to: "/manage/assists",
      name: "Road Assist",
      icon: <MdAddRoad />,
    },
    {
      id: 5,
      isActive: false,
      to: "/manage/testdrives",
      name: "Test Drives",
      icon: <SiSpeedtest />,
    },
    {
      id: 14,
      isActive: false,
      to: "/manage/finances",
      name: "Finances",
      icon: <AiOutlineCreditCard />,
    },
    {
      id: 6,
      isActive: false,
      to: "/manage/users",
      name: "Users",
      icon: <FiUserCheck />,
    },
    {
      id: 7,
      isActive: false,
      to: "/manage/roles",
      name: "Roles",
      icon: <IoIdCardOutline />,
    },
    {
      id: 6,
      isActive: false,
      to: "/manage/firms",
      name: "KJL Companies",
      icon: <FiUserCheck />,
    },
    {
      id: 8,
      isActive: false,
      to: "/manage/models",
      name: "Models",
      icon: <IoCarSportOutline />,
    },
    {
      id: 9,
      isActive: false,
      to: "/manage/vehicles",
      name: "Vehicles",
      icon: <RiPoliceCarLine />,
    },
    {
      id: 10,
      isActive: false,
      to: "/manage/sites",
      name: "Sites",
      icon: <GoLocation />,
    },
    {
      id: 11,
      isActive: false,
      to: "/manage/qrcodes",
      name: "QR Codes",
      icon: <AiOutlineScan />,
    },
  ];

  const menus = user?.role?.name === "Super Admin" ? adminMenus : allMenus;

  return (
    <div className="grid grid-cols-12 gap-0 m-4 border rounded-lg ">
      <div className="bg-gray-50 col-span-2 rounded-l-lg border-r">
        {menus.map((menu: any, index: number) => (
          <AdminLink to={`${menu.to}`} icon={menu.icon} key={index}>
            {menu.name}
          </AdminLink>
        ))}
      </div>
      <div className="bg-white col-span-10 h-full rounded-r-lg">
        <div className="border-b p-4 flex justify-between items-center h-18">
          <div className="flex justify-center items-center">
            {hasLogo ? (
              <div className="mr-2 border-r pr-2">
                <img src={logo} alt="Logo" height={20} width={50} />
              </div>
            ) : null}
            <div className="">
              <span className="text-lg font-bold">{title} : </span>
              <span>{subtitle}</span>
              <div className="">{description}</div>
            </div>
          </div>
          {actions}
        </div>
        {children}
      </div>
    </div>
  );
}
